import React from 'react'
import CommonLoader from '../Alerts/CommonLoader'
import t from '../Language/language'
import * as languageSettings from '../Language/languageSettings'
import AuthenticationService from '../Security/AuthenticationService'
import { Config } from '../../Config'
// import { CommonConstants } from '../../Constants'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import './AccountInfo.css'
import 'react-confirm-alert/src/react-confirm-alert.css'
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css'
import ReactTooltip from 'react-tooltip'
import { GetAccountInfo, UpdateAccountInfo } from '../../actions/account'
import { Form, Row, Col } from 'reactstrap'
import NavigationServices from '../Common/NavigationServices'
var _ = require('underscore')
// AccountInfo - Component

class AccountInfo extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      language: languageSettings.getCurrentLanguage(),
      successMessage: '',
      errorMessage: [],
      editAccountInfo: true,
      accountId: 100,
      groupId: null,
      saveSuccess: props.saveSuccess,
      formIsValid: true,
      isAgree: true,
      showLoader: true,
      accountInfo: {
        corporateShare: []
      },
      userEmail: '',
      isShared: true,
      userContext: {}
    }
    this.navigation = new NavigationServices()
    this.state.accountInfo.sharedStore = []
    this.state.userContext.IsAccountOwner = 1
    this.authService = new AuthenticationService(Config.authBaseUrl)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.renderCorporateShareInfo = this.renderCorporateShareInfo.bind(this)
    this.getXMLSharedData = this.getXMLSharedData.bind(this)
    this.CorporateSharedTable = this.CorporateSharedTable.bind(this)
  }

  // Before submit check input validation and if any errors comes throw the particular error
  handleValidation () {
    const language = this.state.language
    const fields = this.state.accountInfo
    const userEmail = this.state.userEmail
    let errors = []
    let formIsValid = true
    const newPassword = fields.newPassword
    const confirmPassword = fields.confirmNewPassword
    // Password Validation
    var reemail = new RegExp(/^([a-zA-Z0-9_\-.+])+@(([0-2]?[0-5]?[0-5]\.[0-2]?[0-5]?[0-5]\.[0-2]?[0-5]?[0-5]\.[0-2]?[0-5]?[0-5])|((([a-zA-Z0-9-])+\.)+([a-zA-Z-])+))$/)
    var relower = new RegExp('[a-z]{1,}')
    var reupper = new RegExp('[A-Z]{1,}')
    var renumeric = new RegExp('[0-9]{1,}')

    if (_.isEmpty(fields.currentPassword) && (!_.isEmpty(fields.newPassword) || !_.isEmpty(fields.confirmPassword))) {
      formIsValid = false
      errors.push(t[language].passwordblank)
    }

    if (!_.isEmpty(fields.currentPassword)) {
      if (newPassword !== undefined && newPassword.length >= 8 && newPassword.length <= 16) {
        if (newPassword.indexOf(' ') >= 0) {
          formIsValid = false
          errors.push(t[language].newPasswordcontainblank)
        }
        if (!relower.test(newPassword)) {
          formIsValid = false
          errors.push(t[language].newPasswordlowercase)
        }
        if (!reupper.test(newPassword)) {
          formIsValid = false
          errors.push(t[language].newPassworduppercase)
        }
        if (!renumeric.test(newPassword)) {
          formIsValid = false
          errors.push(t[language].newPasswordnumber)
        }
      } else {
        formIsValid = false
        errors.push(t[language].newPasswordsize)
      }
      if (confirmPassword !== undefined && confirmPassword.length >= 8 && confirmPassword.length <= 16) {
        if (confirmPassword.indexOf(' ') >= 0) {
          formIsValid = false
          errors.push(t[language].confirmPasswordcontainblank)
        }
        if (!relower.test(confirmPassword)) {
          formIsValid = false
          errors.push(t[language].confirmPasswordlowercase)
        }
        if (!reupper.test(confirmPassword)) {
          formIsValid = false
          errors.push(t[language].confirmPassworduppercase)
        }
        if (!renumeric.test(confirmPassword)) {
          formIsValid = false
          errors.push(t[language].confirmPasswordnumber)
        }
      } else {
        formIsValid = false
        errors.push(t[language].confirmPasswordsize)
      }

      if (newPassword !== confirmPassword) {
        formIsValid = false
        errors.push(t[language].passwordnomatch)
      }
    }

    if (fields.resetPassword) {
      if (fields.currentPassword === undefined ||
        fields.currentPassword == null) {
        formIsValid = false
        errors.push(t[language].invalidcredentials)
      }

      if (!this.state.isAgree && (fields.AccountTOSAgree === 0 || fields.AccountTOSAgree === null)) {
        formIsValid = false
        errors.push(t[language].blankterms)
      }
    } else {
      if (!this.state.isAgree && (fields.AccountTOSAgree === 0 || fields.AccountTOSAgree === null)) {
        formIsValid = false
        errors.push(t[language].blankterms)
      }
    }

    // Email Address
    if ((!fields['userEmail'] || !reemail.test(fields['userEmail'])) ||
        (!userEmail || !reemail.test(userEmail))) {
      formIsValid = false
      errors.push(t[language].emailinvalid)
    }

    if (!fields['firstName']) {
      formIsValid = false
      errors.push(t[language].pleasefillinfirstname)
    }

    if (!fields['lastName']) {
      formIsValid = false
      errors.push(t[language].pleasefillinlastname)
    }

    this.setState({ errorMessage: errors, formIsValid: formIsValid })
    return formIsValid
  }

  // Input onchange function
  handleInputChange (event) {
    let accountInfo = this.state.accountInfo
    let userEmail = this.state.userEmail
    const value = event.target.value
    const name = event.target.name
    if (name === 'ViewFranchise') {
      accountInfo[name] = event.target.checked ? 1 : 0
    } else if (name === 'isAgree') {
      accountInfo[name] = event.target.checked
      this.setState({ isAgree: accountInfo[name] })
    } else if (name === 'userEmail') {
      userEmail = value
    } else {
      accountInfo[name] = value
    }
    this.setState({ accountInfo, userEmail })
  }

  // get XML Shared Data using account info
  getXMLSharedData () {
    let accountInfo = this.state.accountInfo
    let corporateShare = accountInfo.corporateShare
    let strXML = '<AccountBrandShared>'
    corporateShare.map((item) => {
      strXML += '<Store AccountID="' + accountInfo.ownerAccountId + '" BrandID="' + item.brandId + '" BrandName="' + item.brandName + '" Shared="' + item.brandShared + '"/>'
    })
    strXML += '</AccountBrandShared>'
    return strXML
  }

  // submit function
  handleSubmit () {
    let errors = this.state.errorMessage
    const language = this.state.language

    let data = this.state.accountInfo
    if (this.handleValidation()) {
      this.setState({ showLoader: true })
      data.changeEmail = this.state.userEmail
      errors = []
      data['SharedData'] = this.getXMLSharedData()
      if (data.currentPassword === undefined || _.isEmpty(data.currentPassword)) {
        data['typeOfUpdate'] = 'AccountUpdate'
      } else if (data.currentPassword) {
        data['typeOfUpdate'] = 'AllUpdate'
      }
      data['language'] = parseInt(this.state.language)
      // Update the account Information
      // If any errors comes display that errors
      this.props.UpdateAccountInfo(data, result => {
        if (result.validPassword !== undefined && !result.validPassword) {
          // errors.push(t[language].passwordnotmatchsystem)
          errors.push(t[language].invalidcredentials)
          const formIsValid = false
          this.setState({ errorMessage: errors, formIsValid, showLoader: false })
        } else {
          if (result.status) {
            if (data.resetPassword === 1) {
              data.resetPassword = 0
            }
            if (data.AccountTOSAgree === null || data.AccountTOSAgree === 0) {
              data.AccountTOSAgree = 1
            }
            data.currentPassword = ''
            data.newPassword = ''
            data.confirmNewPassword = ''
            data.userEmail = data.changeEmail
            this.setState({ saveSuccess: true, successMessage: t[this.state.language].savesuccessful, accountInfo: data, showLoader: false })
            this.props.onSaveSuccess()
          } else {
            if (result.message === 'emailused') {
              let errors = this.state.errorMessage
              errors.push(t[this.state.language].emailused)
              this.setState({ errorMessage: errors, formIsValid: false, showLoader: false })
            }
          }
        }
      })
    }
  }

  // Using React lifescycle method and call all inside function after page load
  componentDidMount () {
    this.props.GetAccountInfo()
  }

  // Using React lifescycle method and check the compare the state before page load
  componentWillReceiveProps (newProps) {
    if (newProps.userInfo) {
      this.setState({
        accountInfo: newProps.userInfo,
        userEmail: newProps.userInfo.userEmail,
        showLoader: false,
        isAgree: (newProps.userInfo.AccountTOSAgree !== null && newProps.userInfo.AccountTOSAgree !== 0)
      })
    }
  }
  // Displaying Corporate Shared stores
  CorporateSharedTable (userInfo) {
    if (userInfo.IsCorporate === 0 && userInfo.IsOwner === 1 && userInfo.corporateShare.length > 0) {
      return (<tr>
        <td colspan='2' className='share_table'>
          <table>
            <tbody>
              <tr>
                <th className='shared_font' colspan='2'>
                  <label htmlFor='Share_Data'>
                    <span translate='' key='sharedatawithcorp'>{t[this.state.language].sharedatawithcorp}</span>&nbsp;|&nbsp;
                    <a className='agreement' href={Config.storageUrl + '/' + t[this.state.language].agreementUrl} translate='' key='agreement'>{t[this.state.language].agreement}</a>
                  </label>
                </th>
              </tr>
              <tr>
                <td>
                  {this.renderCorporateShareInfo(userInfo.corporateShare)}
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>)
    } else {
      return <tr />
    }
  }
  // Displaying Corporate Shared stores
  renderCorporateShareInfo (corporateShare) {
    // let self = this
    if (corporateShare.length) {
      return corporateShare.map(item => {
        if (item.brandName !== null && item.brandName !== undefined && !_.isEmpty(item.brandName)) {
          return (
            <table className='shared-data'>
              <tr>
                <th className='shared_font' colspan='2'>
                  <label htmlFor='Share_Data'>{item.brandName}</label>
                </th>
              </tr>
              <tr>
                <td className='shared_font'>
                  <input type='radio' name={item.brandId} onChange={(e) => this.corporateShareOnChange(e)} checked={item.brandShared === 1} />
                  <label htmlFor='Share_Data8' translate='' key='shared'>{t[this.state.language].shared}</label>
                </td>
                <td className='shared_font'>
                  <input type='radio' name={item.brandId} onChange={(e) => this.corporateShareOnChange(e)} checked={item.brandShared === 0} />
                  <label htmlFor='Share_Data8' translate='' key='notshared'>{t[this.state.language].notshared}</label>
                </td>
              </tr>
            </table>
          )
        } else {
          return <div />
        }
      })
    } else {
      return <div />
    }
  }

  //  Corporate Shared stores on change event
  corporateShareOnChange (e) {
    let accountInfo = this.state.accountInfo
    accountInfo.corporateShare.map(item => {
      if (item.brandId === parseInt(e.target.name)) {
        item.brandShared = (item.brandShared === 0) ? 1 : 0
      }
    })
    this.setState({ accountInfo: accountInfo })
  }

  //  Render the main function and displaying account information
  render () {
    let language = this.state.language
    const showLoader = this.state.showLoader
    let userInfo = {}
    let userEmail = this.state.userEmail
    if (this.props.userInfo != null) {
      userInfo = this.props.userInfo
    }
    const populateError = (errors) => {
      return errors.map(error => {
        return <li>{error}</li>
      })
    }
    // Before Displaying user information check the user information is null or undefind
    if (this.props.userInfo != null && userInfo.store !== undefined) {
      return (
        <section className='myaccount'>
          <div className={showLoader ? 'show' : 'hide'}>
            <CommonLoader showLoader={showLoader} message={t[language].settingsStoresLoadingMessage1} language={language} />
          </div>
          <div className={this.props.saveSuccess && !showLoader ? 'show' : 'hide'}>
            <div className='forms clear'>
              <div className='appr' >
                <h4 translate='' key='recordsaved'>{this.state.successMessage}</h4>
              </div>
            </div>
          </div>
          <section className={'report-container ' + (this.props.saveSuccess || showLoader ? 'hide' : 'show')}>
            <div>
              <h3>{t[language].accountinfo}</h3>
            </div>
            <div>
              <div className={'alert alert-danger errors ' + (this.state.formIsValid ? 'hide' : 'show')} >
                <ul> {populateError(this.state.errorMessage)}</ul>
              </div>
            </div>
            <Form>
              <Row className='account-container'>
                <h5 translate='' key='userinfo'>{t[language].userinfo}</h5>
                <Col lg='6' className='row'>
                  <table className='account-form'>
                    <tbody>
                      <tr>
                        <td><label htmlFor='userEmail' translate='' key='user name' >{t[language]['user name']}</label></td>
                        <td><input type='text' maxLength='100' name='userEmail' value={userEmail} onChange={(e) => { this.handleInputChange(e) }} /></td>
                      </tr>
                      <tr>
                        {language === 1
                          ? <th><label htmlFor='User_EmailAddress'>
                            <a href={this.navigation.getUrl('roles')}>
                              <span translate key='Role'>{t[language].Role}</span>
                            </a>&nbsp;
                            <span translate key='User'>{t[language].User}</span> :</label>
                          </th>
                          : <td>
                            <label >
                              <span translate='' key='user'>{t[language].user}</span>
                              <a href={this.navigation.getUrl('roles')}>
                                <span translate='' key='role'> {t[language].role} </span>
                              </a> :
                            </label>
                          </td>}
                        <td><input type='text' maxLength='100' name='User_Role' value={userInfo.roleName} disabled='disabled' /></td>
                      </tr>
                      <tr>
                        <td className='t_top'><label htmlFor='store.stores' translate='' key='userstoreaccess'>{t[language].userstoreaccess}</label></td>
                        <td>&nbsp;<textarea cols='35' rows='3' disabled='disabled' value={(userInfo.store === null ? '' : userInfo.store.stores)} /></td>
                      </tr>
                      <tr>
                        <th colspan='2' className={(userInfo.resetPassword === 1 ? 'show' : 'hide')}>
                          <div className='error'><p translate='' key='passchangereq'>{t[language].passchangereq}</p></div>
                        </th>
                      </tr>
                      <tr>
                        <td className='req'><label htmlFor='currentPassword' translate='' key='currentpassword'>{t[language].currentpassword}</label></td>
                        <td><input type='password' maxLength='16' name='currentPassword' value={userInfo.currentPassword} onChange={(e) => { this.handleInputChange(e) }} /></td>
                      </tr>
                      <tr>
                        <td className='req'><label htmlFor='newPassword' translate='' key='newpassword'>{t[language].newpassword}</label></td>
                        <td><input type='password' maxLength='16' name='newPassword' value={userInfo.newPassword} onChange={(e) => { this.handleInputChange(e) }} /></td>
                      </tr>
                      <tr>
                        <td className='req'><label htmlFor='confirmNewPassword' translate='' key='confirmnewpassword'>{t[language].confirmnewpassword}</label></td>
                        <td><input type='password' maxLength='16' name='confirmNewPassword' value={userInfo.confirmNewPassword} onChange={(e) => { this.handleInputChange(e) }} /></td>
                      </tr>
                      <tr>
                        <th colspan='2' className='passinfo'>
                          <h6 translate='' key='passwordrequirements'>{t[language].passwordrequirements}</h6>
                          <ul>
                            <li translate='' key='lengthofpasswordLi'>{t[language].lengthofpasswordLi}</li>

                            <li translate='' key='passwordblankLi'>{t[language].passwordblankLi}</li>
                            <li><span translate='' key='passwordgroupsLi'>{t[language].passwordgroupsLi}</span>
                              <ul>
                                <li translate='' key='passwordgroupupperLi'>{t[language].passwordgroupupperLi}</li>
                                <li translate='' key='passwordgrouplowerLi'>{t[language].passwordgrouplowerLi}</li>
                                <li translate='' key='passwordgroupnumberLi'>{t[language].passwordgroupnumberLi}</li>
                              </ul>
                            </li>
                          </ul>
                        </th>
                      </tr>
                    </tbody>
                  </table>
                </Col>
                <Col lg='6' className='row'>
                  <table className='account-form'>
                    <tbody>
                      <tr>
                        <td className='req'><label htmlFor='firstName' translate='' key='firstname'>{t[language].firstname}</label></td>
                        <td><input type='text' maxLength='100' name='firstName' value={userInfo.firstName} onChange={(e) => { this.handleInputChange(e) }} /></td>
                      </tr>
                      <tr>
                        <td className='req'><label htmlFor='lastName' translate='' key='lastname'>{t[language].lastname}</label></td>
                        <td><input type='text' maxLength='100' name='lastName' value={userInfo.lastName} onChange={(e) => { this.handleInputChange(e) }} /></td>
                      </tr>
                      <tr>
                        <td><label htmlFor='jobTitle' translate='' key='jobtitle'>{t[language].jobtitle}</label></td>
                        <td><input type='text' maxLength='100' name='jobTitle' value={userInfo.jobTitle} onChange={(e) => { this.handleInputChange(e) }} /></td>
                      </tr>
                      <tr>
                        <td><label htmlFor='officeNumber' translate='' key='officenum'>{t[language].officenum}</label></td>
                        <td><input type='text' maxLength='20' name='officeNumber' value={userInfo.officeNumber} onChange={(e) => { this.handleInputChange(e) }} /></td>
                      </tr>
                      <tr>
                        <td><label htmlFor='mobilePhone' translate='' key='mobilephone'>{t[language].mobilephone}</label></td>
                        <td><input type='text' maxLength='20' name='mobilePhone' value={userInfo.mobilePhone} onChange={(e) => { this.handleInputChange(e) }} /></td>
                      </tr>
                      <tr>
                        <td><label htmlFor='fax' translate='' key='fax'>{t[language].fax}</label></td>
                        <td><input type='text' maxLength='20' name='fax' value={userInfo.fax} onChange={(e) => { this.handleInputChange(e) }} /></td>
                      </tr>
                      { (userInfo.IsCorporate === 1 && userInfo.IsOwner === 1)
                        ? <tr>
                          <th colSpan='2'><span className='viewFranchise' translate key='viewFranchise'>{t[language].viewFranchise}</span>
                            <a data-tip={t[language].franchiseHelp} data-html>
                              <span className='tip openTip'>?</span>
                            </a>
                            <ReactTooltip place='right' type='dark' effect='solid' className='tooltip viewTipCont viewfranchise' />
                              &nbsp;
                            <input className='franchise' type='checkbox' name='ViewFranchise' checked={userInfo.ViewFranchise === 1} onChange={(e) => { this.handleInputChange(e) }} />
                          </th>
                        </tr >
                        : <tr />
                      }
                      <tr className={(userInfo.AccountTOSAgree === 1 ? 'hide' : 'show')}>
                        <td colSpan='2'><div className='error terms_agree'><p translate='' key='termagreementreq'>{t[language].termagreementreq}</p></div></td>
                      </tr>
                      <tr className={(userInfo.AccountTOSAgree === 1 ? 'hide' : 'show')}>
                        <td colSpan='2'>
                          <table className='shared_marg'>
                            <tbody>
                              <tr>
                                <td colspan='2' className='terms shared_font terms_pad'>
                                  <input type='checkbox' name='isAgree' id='agreement' checked={this.state.isAgree ? 'checked' : ''} onChange={(e) => { this.handleInputChange(e) }} />&nbsp;
                                  <span translate='' key='agreetohme'>{t[language].agreetohme}</span>&nbsp;
                                  <a className='terms' href={Config.storageUrl + '/' + t[this.state.language].agreementUrl} target='_blank' translate='' key='termsofservice'>{t[language].termsofservice}</a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      { this.CorporateSharedTable(userInfo) }
                      <tr>
                        <td />
                        <td className='accountSpace'>
                          <input type='hidden' name='ResPass' value='' />
                          <button type='button' onClick={this.handleSubmit} value='Save' className='fnone' translate='' key='save'>{t[language].save}</button>
                            &nbsp;|&nbsp;<a className='cancel_butt' href='/welcome' translate='' key='cancel'>{t[language].cancel}</a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Col>
              </Row>
            </Form>
          </section>
        </section>
      )
    } else { return <div /> }
  }
}
// Call the Redux action and set the initialstate
function mapStateToProps (state) {
  return {
    userInfo: state.accountinfo.accountDetails
  }
}
function matchDispatchToProps (dispatch) {
  return bindActionCreators(
    {
      GetAccountInfo,
      UpdateAccountInfo
    }, dispatch
  )
}

export default connect(mapStateToProps, matchDispatchToProps)(AccountInfo)



// WEBPACK FOOTER //
// ./src/components/Account/AccountInfo.js